/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/10/2021
 */

import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {TaskJournalEntry} from "./journalEntry-imports";
import {FilterableProperty} from "@shared/Filterable/PropertyDecorators";
import {timestampFormatted} from "@/utils/helpers";
import {PriorityEnum} from "@shared/enums/PriorityEnum";

export default class FormJournalEntry extends TaskJournalEntry {

	@FilterableProperty()
	formTitle: string = null

	priority: PriorityEnum = PriorityEnum.MEDIUM

	formId: string = null
	formAnswerId: string = null

	constructor() {
		super();
		this.type = JournalEntryType.FORM
	}

	dueDateFormatted(){
		if(this.dueDateTs){
			return "Due on " + timestampFormatted(this.dueDateTs)
		}
		return ""//"No Due Date"
	}

	summaryFormatted(){
		return this.formTitle ? "" + this.formTitle : "Form"
	}

	assignFromFileRef(file){
		super.assignFromFileRef(file)
		this.formTitle = file.name
		this.formId = file.id
	}
	assignFromFormItem(formItem){
		this.description = formItem.title
		this.formTitle = formItem.title
		this.formId = formItem.id
	}


}
